module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'page-fixed-height': !_vm.activePanel
    }
  }, [_c('div', {
    staticClass: "sideways-page-one",
    class: {
      'disabled': !_vm.activePanel
    }
  }, [_c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.breadcrumbArray
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Regions")]), _vm._v(" "), _c('div', {
    staticClass: "note note-info"
  }, [_vm._v("\n\t\t\tCreate and manage your business regions.\n\t\t")]), _vm._v(" "), (_vm.noRegions) ? _c('button', {
    staticClass: "btn blue btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.throttledCreate()
      }
    }
  }, [_vm._v("Create Your First Region")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-top-40"
  }, [_c('div', {
    staticClass: "relative-block"
  }, [_c('loading-screen', {
    attrs: {
      "show": _vm.loadingRegionData,
      "color": '#3598dc',
      "display": 'inline'
    }
  }), _vm._v(" "), (_vm.loadingRegionData === false) ? _c('div', [(_vm.regionPath.length) ? _c('span', {
    staticClass: "caption-subject font-blue bold uppercase"
  }, [_vm._v("Regions in " + _vm._s(_vm.regionPath[_vm.regionPath.length - 1].name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-element-list"
  }, [_c('div', {
    staticClass: "mt-list-container list-simple ext-1 group no-border"
  }, [(_vm.regionPath.length) ? _c('a', {
    staticClass: "list-toggle-container",
    on: {
      "click": function($event) {
        _vm.goUpOneLevel()
      }
    }
  }, [_c('div', {
    staticClass: "list-toggle not-selected"
  }, [_c('span', {
    staticClass: "fa fa-chevron-left margin-right-10"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\tGo back to " + _vm._s(_vm.regionPath.length > 1 ? _vm.regionPath[_vm.regionPath.length - 2].name : 'global regions') + "\n\t\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.computedRegions), function(region) {
    return [_c('a', {
      staticClass: "list-toggle-container"
    }, [_c('div', {
      staticClass: "list-toggle uppercase",
      class: {
        'not-selected': _vm.currentRegion.id !== region.id
      },
      on: {
        "click": function($event) {
          _vm.drillDown(region)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(region.name) + "\n\t\t\t\t\t\t\t\t\t\t"), (region.has_children) ? _c('span', {
      staticClass: "pull-right fa fa-chevron-right"
    }) : _vm._e(), _vm._v(" "), _c('dropdown', {
      staticClass: "pull-right margin-right-10 skinny-dropdown",
      class: {
        'margin-right-25': !region.has_children
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
      attrs: {
        "slot": "button",
        "type": "button",
        "data-toggle": "dropdown"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      },
      slot: "button"
    }, [_c('i', {
      staticClass: "fa fa-cogs"
    })]), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu",
      attrs: {
        "slot": "dropdown-menu"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      },
      slot: "dropdown-menu"
    }, [(!region.has_children) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.createRegion(region.id)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tAdd children to "), _c('b', [_vm._v(_vm._s(region.name))])])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.manageLocations(region.id)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tManage "), _c('b', [_vm._v(_vm._s(region.name))]), _vm._v(" locations\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])])])])], 1)])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-20"
  }, [(_vm.regionPath.length) ? _c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createRegion(_vm.regionPath[_vm.regionPath.length - 1].id)
      }
    }
  }, [_vm._v("Add region in " + _vm._s(_vm.regionPath[_vm.regionPath.length - 1].name))]) : _vm._e()])]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "sideways-page-two",
    class: {
      'active': !_vm.activePanel, 'inactive': _vm.activePanel
    },
    style: ({
      height: _vm.computedHeight
    })
  }, [_c('div', {
    staticClass: "sideways-blank-fold"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn blue btn-lg margin-bottom-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v("Return to this page")])])]), _vm._v(" "), _c('create-region'), _vm._v(" "), _c('manage-locations')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07846f46!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/MyBusiness/Regions.vue
// module id = 402
// module chunks = 1